<template>
  <div>
    <h3 class="title is-3">{{ isEdit ? 'Edit a ' : 'Create a new ' }} game</h3>
    <b-steps
        v-model="activeStep"
        :animated="true"
        :has-navigation="false"
        size="is-small">

      <b-step-item label="Basic info">
        <h1 class="title has-text-centered">Basic information</h1>
        <game-step1 :key="gameStep1Key" :game="game" :isEdit="isEdit" :next="nextStep1" @errors="hasStepErrors"
                    @updated="updated"></game-step1>
      </b-step-item>

      <b-step-item label="Map">
        <h1 class="title has-text-centered">Choose a map</h1>
        <game-step2 :key="gameStep2Key" :game="game" :isEdit="isEdit" :next="nextStep2" @errors="hasStepErrors"
                    @updated="updated"></game-step2>
      </b-step-item>

      <b-step-item label="Activities">
        <h1 class="title has-text-centered">Pick activities</h1>
        <game-step3 :key="gameStep3Key" :game="game" :isEdit="isEdit" :next="nextStep3" @errors="hasStepErrors"
                    @updated="updated"></game-step3>
      </b-step-item>

      <b-step-item label="Parameters">
        <h1 class="title has-text-centered">Extra configuration parameters</h1>
        <p class="has-text-centered" style="padding-bottom: 40px; margin-top: -10px">
          <b-icon icon="alert-circle" size="is-small"></b-icon>
          <i>You should leave these fields unchanged unless you know what you are doing...</i>
        </p>
        <game-step4 :key="gameStep4Key" :game="game" :isEdit="isEdit" :next="nextStep4" @errors="hasStepErrors"
                    @updated="updated"></game-step4>
      </b-step-item>

      <b-step-item label="Review">
        <h1 class="title has-text-centered">Review and confirm</h1>
        <game-step5 :key="gameStep5Key" :game="game" :isEdit="isEdit" :next="nextStep5" @errors="hasStepErrors"
                    @updated="updated"></game-step5>
      </b-step-item>
    </b-steps>

    <div class="has-text-centered">
      <b-button
          :type="activeStep === 0 ? 'is-dark' : 'is-light'"
          class="btn-margin"
          icon-left="chevron-left"
          @click.prevent="stepBack"
      >
        Back
      </b-button>
      <b-button icon-right="chevron-right"
                type="is-success"
                @click.prevent="stepNext"
      >
        {{ activeStep === 4 ? 'Finish' : 'Next' }}
      </b-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import GameStep1 from './GameStep1'
import GameStep2 from './GameStep2'
import GameStep3 from './GameStep3'
import GameStep4 from './GameStep4'
import GameStep5 from './GameStep5'
import gamesService from '../../services/gamesService'
import displayHelper from '../../helpers/display-helper'

export default {
  components: {
    GameStep1,
    GameStep2,
    GameStep3,
    GameStep4,
    GameStep5,
  },
  data() {
    return {
      activeStep: 0,
      game: {},

      isEdit: false,

      nextStep1: false,
      nextStep2: false,
      nextStep3: false,
      nextStep4: false,
      nextStep5: false,

      gameStep1Key: 0,
      gameStep2Key: 0,
      gameStep3Key: 0,
      gameStep4Key: 0,
      gameStep5Key: 0,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.gameId = this.$route.params.id
      this.loadGameById(this.gameId)
    }
  },
  methods: {
    stepNext() {
      // console.log(this.game)
      this[`nextStep${this.activeStep + 1}`] = true
    },
    stepBack() {
      if (this.activeStep === 0) {
        this.$router.go(-1)
      } else {
        this.activeStep -= 1
      }
    },
    updated(updatedGame) {
      this[`nextStep${this.activeStep + 1}`] = false

      if (updatedGame.map) {
        if (this.game.map && (updatedGame.map.id !== this.game.map.id)) {
          delete this.game.map
          delete this.game.chosenPack
          delete this.game.associationMarkersActivities
        }
      }
      this.game = _.merge(this.game, updatedGame)

      this.activeStep += 1

      // to force steps to refresh
      this.gameStep1Key++
      this.gameStep2Key++
      this.gameStep3Key++
      this.gameStep4Key++
      this.gameStep5Key++
    },
    hasStepErrors() {
      this[`nextStep${this.activeStep + 1}`] = false
    },
    // EDIT
    loadGameById(id) {
      let parent = this

      gamesService.getGameById(id)
          .then((game) => {
            this.game = game
            this.isEdit = true

            console.log('logging edit game')

            if (_.get(game, 'wizardInformation.creationMode') !== 'Wizard') {
              // this should not happen, unless someone copies and pastes game ids in the wrong path...
              displayHelper.displayError(parent, 'This game has not been created with the Wizard, please contact your administrator')
              this.$router.go(-1)
            }

            // remettre les infos wizardInformation à la racine
            _.assign(this.game, this.game.wizardInformation)
            delete this.game.wizardInformation
            delete this.game.tenantId
            delete this.game.gameZoom
            delete this.game.gameLatitude
            delete this.game.gameLongitude

            console.dir(this.game)

            // force refresh
            this.gameStep1Key++
            this.gameStep2Key++
            this.gameStep3Key++
            this.gameStep4Key++
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Unable to load this game: ' + err.message)
          })
    }
  },
}
</script>
<style scoped>
.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
